import { Position } from "@perp/sdk-curie"
import { ChartingLibraryWidgetOptions } from "asset/charting_library/charting_library"
import TradingViewWidget from "./TradingViewWidget"

interface ChartSetting {
    charts: { panes: { sources: { state: { interval: string } }[] }[] }[]
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const parseChartSetting = (chartSetting?: ChartSetting) => {
    const interval = chartSetting?.charts[0]?.panes[0]?.sources[0]?.state
        ?.interval as ChartingLibraryWidgetOptions["interval"]
    return {
        ...(interval && { interval }),
        ...(chartSetting && { saved_data: chartSetting }),
    }
}

interface TradingViewChartProps {
    tickerSymbol: string
    position: Position | undefined
    isAdvanced?: boolean
}

export function PriceChart({ tickerSymbol, position, isAdvanced = true }: TradingViewChartProps) {
    return <TradingViewWidget symbol={tickerSymbol} />
}
